import { render, staticRenderFns } from "./SecondBlock.vue?vue&type=template&id=07f4eda8&scoped=true"
import script from "./SecondBlock.vue?vue&type=script&lang=js"
export * from "./SecondBlock.vue?vue&type=script&lang=js"
import style0 from "./SecondBlock.vue?vue&type=style&index=0&id=07f4eda8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f4eda8",
  null
  
)

export default component.exports